export default (props, vars) =>
  `${props?.['thickness'] || '4px'} ${
    props?.['color'] || 'rgba(0, 0, 0, 0.25)'
  } solid`;
